import { render, staticRenderFns } from "./sw-tfa-dialog.vue?vue&type=template&id=05fe5d14&scoped=true&"
import script from "./sw-tfa-dialog.vue?vue&type=script&lang=ts&"
export * from "./sw-tfa-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./sw-tfa-dialog.vue?vue&type=style&index=0&id=05fe5d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fe5d14",
  null
  
)

export default component.exports